module.exports = __webpack_public_path__ + "static/media/spo.03fe416a.png";